import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { SubCategory } from "../sub-category";
import { type SubCategoryFieldConfig } from "./entity";

export const SubCategoryFieldConfigEntityConfig: HyperEntityConfig<SubCategoryFieldConfig> =
{
  allowApiRead: true,
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      subCategory: {
        $is: await copyApiPrefilterPerRole(SubCategory),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, {
      subCategory: {
        $is: {
          category: {
            $is: {
              organization: {
                $id: remult.user!.organizationId!,
              },
            },
          },
        },
      },
    });
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, {
      subCategory: {
        $is: {
          category: {
            $is: {
              organization: {
                $id: remult.user!.organizationId!,
              },
            },
          },
        },
      },
    });
  },
};
